import {BrowserOtelState} from './types';

export const BROWSER_ERROR_DEDUPE_WINDOW_MS = 30_000;
export const DEFAULT_SERVICE_NAME = 'unknown-service';
export const DEFAULT_ENVIRONMENT = 'local';

export const BROWSER_ERROR_IGNORED_URL_PATTERNS = [
  /\/v1\/traces$/,
  /\/v1\/logs$/,
  /\/v1\/metrics$/,
] satisfies ReadonlyArray<RegExp>;

// Preserves behavior across Strict Mode remounts, where React mounts, unmounts,
// and mounts the component again during development.
export const BROWSER_OTEL_STATE: BrowserOtelState = {
  activeMounts: 0,
  listenersAttached: false,
  recentBrowserErrorKeys: new Map(),
};
